import CommunicationService from "../../../shared/services/CommunicationService";
import { db } from "../../../shared/plugins/firebase-app";

const communicationService = new CommunicationService(db);
export default communicationService;
